<template>
  <div class="stepper">
    <naj-button
      v-for="(step, index) in steps"
      :key="step.title.split(' ').join('')"
      text
      class="step-item"
      :class="{active: currentStep === (index + 1), done: currentStep > (index + 1)}"
      @click.native="updateCurrentStep(index)"
    >
      <div class="step-icon">
        <span v-if="currentStep <= (index + 1)">{{ index + 1 }}</span>
        <v-icon
          v-if="currentStep > (index + 1)"
          color="white"
        >
          mdi-check
        </v-icon>
      </div>
      <div class="step-name">
        {{ step.title }}
      </div>
    </naj-button>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

const { mapGetters } = createNamespacedHelpers('LawsuitModule');

export default {
  name: 'NajStepper',
  props: {
    steps: {
      required: true,
      validator: function (value) {
        return value.some((e) => {
          const keys = Object.keys(e);
          // eslint-disable-next-line eqeqeq
          return keys.indexOf('title') != -1;
        });
      },
    },
    currentStep: { required: false },
  },
  computed: { ...mapGetters(['isEditMode', 'isViewMode']) },
  methods: {
    updateCurrentStep (stepIndex) {
      const enabled = false;
      if (enabled && (this.isEditMode || this.isViewMode)) {
        this.$router.push(`./${+stepIndex + 1}`);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/partials/_mixins.scss';
.stepper {
  display: flex;

  .step-item {
    margin-left: 15px;
    display: flex;
    align-items: center;

    .step-name {
      color: #dbdbdb;
      font-weight: 700;
      font-size: 14px;
    }

    .step-icon {
      width: 24px;
      height: 24px;
      border-radius: 100%;
      background-color: #dbdbdb;
      margin-left: 10px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #fff;
      font-weight: 700;
      flex-shrink: 0;
    }

    &.active {
      .step-name {
        color: var(--app-primary-color);
      }
      
      .step-icon {
        background-color: var(--app-primary-color);
      }
    }

    &.done {
      .step-name {
        color: var(--app-dark-primary-color);
      }
      .step-icon {
        background-color: var(--app-secondary-color);
      }
    }

  }
}

@include md-down {
  .stepper {
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: flex-end;
    gap: 2px;

    .step-item {
      flex: 1 1 0;
      min-width: 0;
      margin-left: 0;
      display: block;
      width: 100%;
      overflow: hidden;

      &::v-deep .naj-button.v-btn {
        min-width: 0 !important;
        width: 100%;
        height: auto !important;
        padding: 0 !important;
        margin: 0 !important;
      }

      &::v-deep .v-btn__content {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-end;
        width: 100%;
        max-width: 100%;
      }

      .step-name {
        order: 1;
        font-size: 11px;
        line-height: 1.25;
        text-align: center;
        white-space: normal;
        word-break: break-word;
        overflow-wrap: anywhere;
        margin-bottom: 6px;
        width: 100%;
        min-height: 23px;
        max-height: 23px;
        display: flex;
        align-items: flex-end;
        justify-content: center;
        overflow: hidden;
      }

      .step-icon {
        order: 2;
        margin-left: 0;
        width: 22px;
        height: 22px;
        font-size: 12px;
        flex-shrink: 0;
      }
    }
  }
}
</style>
